<template>
  <div v-if="valueIsDefined">
    <span v-if="selectAll">{{ selectAll }}</span>
    <common-sample-status-badge
      v-else
      :status="value"
    />
  </div>
</template>

<script>

import Vue from 'vue'
import CommonSampleStatusBadge from '@/components/common/CommonSampleStatusBadge'
import i18n from '@/lang/i18n'

export default Vue.extend({
    name: 'CommonSampleStatusRenderer',
    components: {
        CommonSampleStatusBadge
    },
    computed: {
        valueIsDefined() {
            return this.params.value !== undefined
        },
        value() {
            if (this.params.isFilterCellRenderer) {
                return this.params.states.find((state) => state.code === this.params.value)
            }
            return this.params.value
        },
        selectAll() {
            return this.params.value === i18n.t('component.agGrid.selectAll')
                ? this.params.value : null
        }
    }
})

</script>
